"use strict";

import angular from "angular";

import template from "./csc-indicator.component.ng.html";
import "./csc-indicator.component.scss";

const __nuCscIndicator = {
    name: "nuCscIndicator",
    factory: [
        function () {
            return {
                restrict: "E",
                replace: true,
                template,
                scope: {
                    fontIcon: "=",
                    svgIcon: "=",
                    value: "=",
                    titleText: "="
                },
                bindToController: true,
                controllerAs: "vm",
                controller: function () {}
            };
        }
    ]
};
angular.module("nucont.shared").directive(
    __nuCscIndicator.name,
    __nuCscIndicator.factory
);
export default __nuCscIndicator;
